module.exports = __webpack_public_path__ + "img/AELogo.ebbc67f8.png";